import { Container } from "@mui/material";
import { currentUserSelector } from "components/login/logic/actions";
import { actions } from "components/settings/user/form/logic/actions";
import { ACTION_STATES } from "core/actions";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import UserForm from "../settings/user/form/userForm";

function Profile() {
    const dispatch = useDispatch();
    const formStatus = useSelector((state) => state.userForm.formStatus);
    const user = useSelector(currentUserSelector);
    const navigate = useNavigate();

    const id = user.id;

    useEffect(() => {
        dispatch(actions.LOAD_USER.send(id));
    }, [dispatch, id]);

    function handleCancel() {
        navigate(-1);
    }

    if (formStatus === ACTION_STATES.SUCCESS) {
        return (
            <Container maxWidth={"xl"} className={"atsGlobalContainer"}>
                <UserForm onCancel={handleCancel} />
            </Container>
        );
    }
    
    return <div>Loading...</div>;
}

export default Profile;
